import React, { useEffect, useState } from 'react'
import './edit-picture-modal.scss'
import Button from '../../atoms/button/button'
import AuthService from '../../../services/auth-service'
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const EditPictureModal = props => {
  const { setshowingEditPicture, setInfoUser, mobile } = props

  const [loadedComponent, setloadedComponent] = useState(false)
  const [activeAvatar, setactiveAvatar] = useState(null)
  const [imgFileInput, setimgFileInput] = useState(null)
  const [imgBase64, setimgBase64] = useState(null)

  const [imgsError, setimgsError] = useState(false)
  const [disableButton, setdisableButton] = useState(false)

  // var dbProfilePicture = JSON.parse(localStorage.getItem('USER_INFO')).profilePicture

  useEffect(() => {
    setloadedComponent(true)

    // setTimeout(() => {
    //     setleftActive(false)
    // }, 2000);
  }, [])

  const handleClose = () => {
    setloadedComponent(false)
    setTimeout(() => {
      setshowingEditPicture(false)
    }, 500);
  }

  var listAvatars = [
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-almohada.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-fuego.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-granito.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-huevo.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-mentruaci%C3%B3n.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-nube.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-ni%C3%B1a1.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-ni%C3%B1a2.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-ni%C3%B1a3.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-ni%C3%B1a4.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-ni%C3%B1a5.png',
    'https://dev-portals-images.s3.amazonaws.com/NOL/profile/default/img-ni%C3%B1a6.png',
  ]

  const handleSubmit = () => {

    var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken;

    var config = {
      headers: {
        Authorization: tokenId,
      }
    }

    if (!haveError()) {
      setdisableButton(true)
      const fd = new FormData();

      if (activeAvatar !== null) {
        fd.append("avatar", listAvatars[activeAvatar]);
      } else {
        fd.append("image", imgFileInput);
      }

      AuthService.updatePicture(fd, config).then(res => {
        if (res.status === 200) {
          handleClose()
          setInfoUser(res.data)
          localStorage.setItem('USER_INFO', JSON.stringify(res.data))
        } 
      }).catch(e => console.log(e))

    }
  }

  const haveError = () => {
    if (imgFileInput !== null) {
      if (
        (
          getFormat(imgFileInput.name) !== 'jpg' &&
          getFormat(imgFileInput.name) !== 'jpeg' &&
          getFormat(imgFileInput.name) !== 'png'
        ) || (imgFileInput.size > 5242880)
      ) {
        setimgsError(true)
      } else {
        setimgsError(false)
      }
    }

    return (
      (
        imgFileInput !== null ?
          (
            getFormat(imgFileInput.name) !== 'jpg' &&
            getFormat(imgFileInput.name) !== 'jpeg' &&
            getFormat(imgFileInput.name) !== 'png'
          ) || (imgFileInput.size > 5242880)
          :
          false
      )
    )
  }

  const getFormat = (name) => {
    return name.split('.')[name.split('.').length - 1].toLowerCase();
  }

  const handleChangeAvatar = (ava) => {
    setimgFileInput(null)
    setimgBase64(null)
    setactiveAvatar(ava)
    setimgsError(false);
  }

  const handleChangeImg = (value) => {
    setactiveAvatar(null)
    setBase64(value)
    setimgFileInput(value)
    setimgsError(false);
  }

  const setBase64 = (value) => {
    var reader = new FileReader();
    reader.onloadend = function () {
      setimgBase64(reader.result)
    }
    reader.readAsDataURL(value);
  }

  var settings = {
    infinite: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <div className={"f-edit-picture-container " + (loadedComponent ? 'showing' : '')}>
      <span
        className="icon2-close f-close-icon"
        onClick={() => handleClose()}
      />

      <label className="f-title-edit-picture">Cambia tu foto de perfil</label>
      <label className="f-subtitle-edit-picture">SUBE UNA FOTO</label>

      <div className="f-input-img-container">

        {imgBase64 === null ?
          <>
            <div className="f-text-input-position">
              <div className="f-rotate-container">
                <span className="f-icon icon-exit f-exit-icon" />
              </div>
              {mobile ?
                <>
                  <label className="f-top-label">Ve a la galeria y</label>
                  <label className="f-bottom-label">Elige tu imagen de perfil</label>
                </>
                :
                <>
                  <label className="f-top-label">Arrastra la imagen que quieras o</label>
                  <label className="f-bottom-label">Explora en tu dispositivo</label>
                </>
              }
            </div>

            <input
              className="f-input-file-box"
              type="file"
              name="f-profile-picture"
              onChange={e => { handleChangeImg(e.target.files[0]); }}
            />
          </>
          :
          <>
            <div className="f-img-prev-container">
              <div
                className="f-icon-clear-container"
                onClick={() => { setimgBase64(null); setimgFileInput(null); }}
              >
                <span
                  className="icon2-close f-close-icon"
                />
              </div>
              <img
                className="f-img-prev"
                alt="Imagen previa"
                src={imgBase64}
              />
            </div>
            {imgsError && <label className="f-img-label-error">*Debe ser jpg o png y no superar 5mb</label>}
          </>

        }
      </div>

      <label className="f-subtitle-edit-picture">O ELIGE UN AVATAR</label>

      <Slider {...settings} className="f-avatars-container">
        <div>
          <div className={"f-avatar-section active"}>
            {listAvatars.map((ava, index) => {
              if (index < 6) {
                return (
                  <div className="f-img-avatar-container" key={index} onClick={() => handleChangeAvatar(index)}>
                    <img
                      className="f-img-avatar"
                      src={ava}
                      alt='Imagen avatar'
                    />

                    {activeAvatar === index &&
                      <div className="f-check-container">
                        <span
                          className="icon-check-2 f-check-icon"
                        />
                      </div>
                    }
                  </div>
                )
              } else {
                return null
              }
            })}

          </div>
        </div>
        <div>
          <div className={"f-avatar-section "}>
            {listAvatars.map((ava, index) => {
              if (index >= 6) {
                return (
                  <div className="f-img-avatar-container" key={index} onClick={() => setactiveAvatar(index)}>
                    <img
                      className="f-img-avatar"
                      src={ava}
                      alt='Imagen avatar'
                    />

                    {activeAvatar === index &&
                      <div className="f-check-container">
                        <span
                          className="icon-check-2 f-check-icon"
                        />
                      </div>
                    }
                  </div>
                )
              } else {
                return null
              }
            })}
          </div>
        </div>
      </Slider>

      <div className={"f-buttons-container " + (disableButton ? 'disable' : '')} onClick={() => handleSubmit()}>
        <Button
          title="Guardar"
          className="primary-blue short fit alter"
        />
      </div>
    </div >
  )
}

export default EditPictureModal
